import {
    NinchatProperties,
    NinchatState,
    NinchatStore,
} from 'api/types'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatRealmMemberJoinedEvent} from '../types/events'
import {extractProperties} from './'

export const realmMemberJoined: CaseReducer<NinchatState> = (state, action) => {
    const {
        user_attrs,
        realm_id,
        user_id,
        member_attrs,
    } = extractProperties<NinchatRealmMemberJoinedEvent>(action.payload)

    if (user_id === state.user_id) {
        state.user_attrs = {
            ...state.user_attrs,
            ...user_attrs,
        }
    } else {
        state._users[user_id] ??= {} as NinchatStore.NinchatStoreUser
        state._users[user_id].user_attrs = {
            ...state._users[user_id].user_attrs,
            ...user_attrs,
        }
    }

    state.user_realms[realm_id] ??= {} as NinchatProperties.NinchatUserRealm
    if (!state.user_realms[realm_id].realm_members) {
        state.user_realms[realm_id].realm_members = {}
    }

    const {realm_members = {}} = state.user_realms[realm_id]
    realm_members[user_id] ??= {} as NinchatProperties.NinchatRealmMember
    realm_members[user_id].member_attrs = member_attrs
}
